import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Lock, Shield, MessageCircle, Eye, Sparkles } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <CheckCircle size={28} data-id="element-41" />,
    title: '真实认证 Verified Profiles',
    desc: '所有伴游均经过身份验证和照片认证，杜绝虚假信息'
  }, {
    icon: <Lock size={28} data-id="element-42" />,
    title: '隐私保护 Privacy Protection',
    desc: '采用端到端加密通讯，绝不泄露客户任何个人信息'
  }, {
    icon: <Shield size={28} data-id="element-43" />,
    title: '安全保障 Safety Guaranteed',
    desc: '严格的安全审核机制，确保每一次服务都安全可靠'
  }, {
    icon: <MessageCircle size={28} data-id="element-44" />,
    title: '24/7客服 24/7 Support',
    desc: '全天候在线客服团队，随时为您解答疑问、处理需求'
  }, {
    icon: <Eye size={28} data-id="element-45" />,
    title: '透明定价 Transparent Pricing',
    desc: '明码标价，无隐藏费用，让您消费得明明白白'
  }, {
    icon: <Sparkles size={28} data-id="element-46" />,
    title: '优质体验 Premium Experience',
    desc: '持续优化服务品质，致力于为您打造极致的伴游体验'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-dark-bg" data-id="element-47">
      {/* Decorative background */}
      <div className="bg-orb w-[600px] h-[600px] bg-pink-primary top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-[0.03]" data-id="element-48"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-49">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-50">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-51">
            为什么选择<span className="text-pink-primary neon-glow" data-id="element-52">我们</span>
          </motion.h2>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full" data-id="element-53"></motion.div>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-54">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-6 rounded-2xl bg-gradient-to-b from-dark-card to-transparent border border-white/5 hover:border-pink-primary/30 transition-colors" data-id="element-55">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-pink-primary/10 flex items-center justify-center text-pink-primary" data-id="element-56">
                {feature.icon}
              </div>
              <div data-id="element-57">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-58">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-59">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}